import CrudManager from "./CrudManager";

const fields = [
  { key: "title", label: "Title (e.g. Skimmer vs Pool Brain)", full: true },
  { key: "slug", label: "Slug (URL)" },
  { key: "status", label: "Status", type: "select", options: ["draft", "published"] },
  { key: "software_slugs", label: "Software slugs (in order)", type: "tags", full: true },
  { key: "intro", label: "Intro", type: "textarea" },
  { key: "rows", label: "Comparison rows", type: "rows" },
  { key: "verdict", label: "Verdict (Markdown)", type: "textarea" },
  { key: "seo_title", label: "SEO title", full: true },
  { key: "seo_description", label: "SEO meta description", type: "textarea" },
];

export default function AdminComparisons() {
  return (
    <CrudManager
      collection="comparisons"
      title="Comparisons"
      singular="comparison"
      fields={fields}
      listColumns={[
        { key: "title", label: "Title" },
        { key: "software_slugs", label: "Products" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
